import PageHeader from "@/components/feature/PageHeader";
import MilestoneTimeline from "./components/MilestoneTimeline";
import TeamSection from "./components/TeamSection";
import ContactPreview from "./components/ContactPreview";
import { useSEO } from "@/hooks/useSEO";
import { siteInfo } from "@/mocks/content";

export default function About() {
  useSEO({
    title: "关于我们 - 白峰美羽",
    description: "了解白峰美羽的品牌背景、发展历程与核心团队，感受以东方审美为根的品牌文化。",
    keywords: "白峰美羽,关于我们,品牌背景,发展历程,核心团队",
  });

  return (
    <>
      <PageHeader
        eyebrow="ABOUT US"
        title="关于我们"
        description={`自 ${siteInfo.establishYear} 年创立以来，白峰美羽始终相信，真正的品质感来自长期耐心。`}
        crumbs={[{ label: "首页", path: "/" }, { label: "关于我们" }]}
      />

      <section className="max-w-site mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950 font-heading leading-snug">
              东方审美为根
              <br />
              现代工艺为翼
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
              白峰美羽创立于 {siteInfo.establishYear} 年，从一间不足六十平米的旧厂房工作室起步，
              用十六年时间建立起一套完整的品牌美学体系。我们专注于材质、比例与细节的长期打磨，
              相信好的品质不靠一次性的惊艳，而是经得起时间检验的耐心。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              今天，白峰美羽已经成长为一个覆盖产品、空间与内容的完整品牌，在多个城市设有品牌体验空间，
              并持续推动可持续发展与材质追溯体系的建设。
            </p>
          </div>
          <div className="relative rounded-lg overflow-hidden h-72 md:h-[380px]">
            <img
              src="https://readdy.ai/api/search-image?query=elegant%20minimal%20brand%20studio%20workspace%20with%20natural%20fabric%20materials%20and%20wooden%20furniture%2C%20warm%20soft%20daylight%2C%20calm%20refined%20editorial%20photography%2C%20muted%20neutral%20tones&width=1000&height=800&seq=about-hero-image&orientation=landscape"
              alt="白峰美羽品牌工作室"
              title="关于白峰美羽 - 品牌背景介绍"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </section>

      <MilestoneTimeline />
      <TeamSection />
      <ContactPreview />
    </>
  );
}